export default __webpack_public_path__ + "static/media/google.ead3bb95.svg";